"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorExtractLinksHeaders = void 0;
const bus_extract_links_1 = require("@comunica/bus-extract-links");
const core_1 = require("@comunica/core");
/**
 * A comunica Traverse Predicates RDF Link Header Actor.
 */
class ActorExtractLinksHeaders extends bus_extract_links_1.ActorExtractLinks {
    constructor(args) {
        super(args);
        this.linkRegEx = /<(.*)>/u;
        this.headers = args.headersRegexes.map(stringRegex => new RegExp(stringRegex, 'u'));
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        return new Promise((resolve, _reject) => {
            const headers = action.headers;
            const links = [];
            for (const regex of this.headers) {
                const linkHeaders = headers?.get('link')?.split(',');
                if (linkHeaders) {
                    for (const header of linkHeaders) {
                        if (regex.test(header)) {
                            const match = this.linkRegEx.exec(header);
                            if (match) {
                                links.push({ url: new URL(match[1], action.url).href });
                            }
                        }
                    }
                }
            }
            resolve({ links });
        });
    }
}
exports.ActorExtractLinksHeaders = ActorExtractLinksHeaders;
//# sourceMappingURL=ActorExtractLinksHeaders.js.map